import { render, staticRenderFns } from "./amenities.vue?vue&type=template&id=f4c27c0a&"
import script from "./amenities.vue?vue&type=script&lang=js&"
export * from "./amenities.vue?vue&type=script&lang=js&"
import style0 from "./amenities.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports